import React, { useState } from 'react'
import { DateTime } from 'luxon'
import { Backdrop, Fade, Modal } from '@material-ui/core'
import EventDetails from './EventDetails'

const Events = (props) => {
  const { cellSize, events, filters, path, rows, screenings, ticketing } = props

  const [modal, setModal] = useState({
    openedId: null,
    track: null,
  })

  const handleOpen = (modalId, track) => {
    setModal({
      openedId: modalId,
      track,
    })
  }

  const handleClose = () => {
    setModal({
      openedId: null,
      track: null,
    })
  }

  return (
    <div
      className='event-cards'
      style={{
        minWidth: cellSize * rows,
        maxWidth: cellSize * rows,
        gridTemplateColumns: `repeat(${rows * 4}, 1fr)`,
      }}
    >
      {events.map((event) => (
        <React.Fragment key={event.id}>
          {(!filters.genres.length ||
            filters.genres.some((r) => (event.genres || []).includes(r))) && (
            <>
              <button
                className={`event-card ${
                  event.festival
                    ? event.festival.toLowerCase().replace(/\s/, '-')
                    : ''
                }`}
                style={{
                  gridColumnStart: event.startPosition + 1,
                  gridColumnEnd: event.endPosition + 1,
                }}
                onClick={() => handleOpen(event.id, null)}
              >
                <div className='event-card__inner'>
                  <h4>{event.title}</h4>
                  <p>
                    {(event.genres || []).length > 0 &&
                      `${event.genres.join(' / ')} / `}

                    {(event.languages || []).length > 0 &&
                      `${event.languages.join(' / ')} / `}

                    {event.runtime &&
                      `${event.runtime}${
                        event.runtime.match(/minutes/) ? '' : ' minutes'
                      }`}
                  </p>

                  <hr />

                  {event.venue && (
                    <h5 className='event-card__location'>{event.venue}</h5>
                  )}

                  <p>
                    {event.start.toLocaleString(DateTime.TIME_SIMPLE)} -{' '}
                    {event.end.toLocaleString(DateTime.TIME_SIMPLE)}
                  </p>
                </div>
              </button>

              <Modal
                open={modal.openedId === event.id}
                onClose={handleClose}
                BackdropComponent={Backdrop}
                closeAfterTransition
              >
                <Fade in={modal.openedId === event.id}>
                  <div>
                    <EventDetails
                      event={event}
                      handleClose={handleClose}
                      festival={event.festival}
                      screenings={screenings}
                      ticketing={ticketing}
                      path={path}
                    />
                  </div>
                </Fade>
              </Modal>
            </>
          )}
        </React.Fragment>
      ))}
    </div>
  )
}

export default Events
